import { ResponsiveBar } from "@nivo/bar";
import React from "react";

export const BarChartGeneral = ({
	layout = "vertical",
	indexBy = "section",
	datas = [],
	keys = [],
	className = "",
	barChartProps = { data: [] },
}) => {
	const commonProps = {
		margin: { top: 60, right: 110, bottom: 60, left: 80 },
		data: datas,
		keys,
		padding: 0.2,
		labelTextColor: "inherit:darker(1.4)",
		labelSkipWidth: 16,
		labelSkipHeight: 16,
		colors: (parent, child) => {
			const nameColor = `${parent.id}Colors`;
			const findColor = parent.data[nameColor];
			return findColor;
		},
	};
	return (
		<div className={className}>
			<ResponsiveBar {...commonProps} {...barChartProps} indexBy={indexBy} layout={layout} />
		</div>
	);
};
